import { Component, Prop, Vue } from 'vue-property-decorator';
import ClFormHelperText from '../ClFormHelperText';
import ClFormLabel from '../ClFormLabel';
import ClInput from '../ClInput';

type Classes = {
  input: string | object;
};

@Component({
  components: {
    ClFormHelperText,
    ClFormLabel,
    ClInput
  }
})
export default class ClTextField extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  readonly autoFocus!: boolean;

  @Prop({
    type: Object as () => Classes,
    default: () => ({
      input: ''
    })
  })
  public classes!: Classes;

  @Prop({ type: Object, default: () => ({}) })
  public clInputProps!: any;

  @Prop({ type: Boolean })
  public disabled!: boolean;

  @Prop({ type: Boolean })
  public error!: boolean;

  @Prop({
    type: Boolean
  })
  public fullWidth!: boolean;

  @Prop({ type: String })
  public helperText!: string;

  @Prop({
    type: String,
    required: true
  })
  public id!: string;

  @Prop(Number)
  public max!: number;

  @Prop(Number)
  public min!: number;

  @Prop({
    type: Boolean,
    default: false
  })
  public multiline!: boolean;

  @Prop(String)
  public label!: string;

  @Prop(String)
  public name!: string;

  @Prop(String)
  public placeholder!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  public readOnly!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  public required!: boolean;

  /**
   * Number of rows to display when multiline option is set to true.
   */
  @Prop({
    type: [Number, String]
  })
  public rows!: number | string;

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  @Prop({
    type: [Number, String]
  })
  public rowsMax!: number | string;

  @Prop(Number)
  public step!: number;

  @Prop(String)
  public type!: string;

  @Prop({
    type: [String, Number, Object, Array]
  })
  public value!: any;
}
